// extracted by mini-css-extract-plugin
export default {"disclaimer":"_13RLU5kuJ7Zp1cZmcxdyqT"};